import i18n from "i18next";
import callIcon from "../../../../public/images/call-for-purchase.svg";
import {ButtonSecondary} from "@/Components/Buttons/ButtonSecondary";
import Modal from "@/Components/Modals/Modal";
import "../../../sass/components/GeneralPurchaseModal.scss";

export default function GeneralPurchaseModal({state, dispatch}) {
    return (
        <Modal isOpen={state.showCheckoutModal}
               dialogClassName="general-purchase-dialog"
               modalClassName="general-purchase-modal"
               setIsOpen={() => dispatch({ type: "showCheckoutModal", payload: { showCheckoutModal: false}})}>
            <h3>{i18n.t("buy-flow.complete-purchase-title")}</h3>
            <div>
                <img src={callIcon} />
                <span>{i18n.t("buy-flow.call")}: 844-523-1186 {i18n.t("buy-flow.complete-purchase-option-1")}</span>
            </div>
            <ButtonSecondary onClick={() => dispatch({ type: "showCheckoutModal", payload: { showCheckoutModal: false}})}>{i18n.t("buy-flow.okay")}</ButtonSecondary>
        </Modal>
    )
}
